import { BreakpointObserver } from '@angular/cdk/layout';
import { DOCUMENT, NgClass, NgIf } from '@angular/common';
import { Component, HostListener, Inject, Input, OnChanges, OnDestroy, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Event as NavigationEvent, Router } from '@angular/router';
import { NullAndEmptyAnchorsService } from 'src/app/shared/services/null-and-empty-anchors.service';
import { TitleComponent } from '../title/title.component';

@Component({
  selector: 'app-newsletter-menu',
  templateUrl: './newsletter-menu.component.html',
  styleUrls: ['./newsletter-menu.component.scss'],
  standalone: true,
  imports: [NgClass, TitleComponent, NgIf],
})
export class NewsletterMenuComponent implements OnChanges, OnDestroy {
  @Input() newsletterContent!: Page;
  @Input() pageSlug!: string;
  expandMenu = false;
  lastScrolledTo?: string;
  forceRescroll: boolean = false;
  isTopMenu: boolean = false;

  constructor(
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private breakpointObserver: BreakpointObserver,
    private uniqueAnchors: NullAndEmptyAnchorsService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.router.events.subscribe((event: NavigationEvent) => {

      if (event instanceof NavigationEnd) {
        if (this.forceRescroll) {
          setTimeout(location.hash = '', 100);
          this.forceRescroll = false;
        } else if (this.lastScrolledTo != null) {
          location.hash = '#' + this.lastScrolledTo;
        }
      }
    });
  }
  ngOnChanges(): void {
    this.titleService.setTitle(this.newsletterContent.Title ?? '');
    this.router.url.includes('DTX_') ? this.routingTabActive() : this.router.url.includes('#') ? this.reloadTabActive() : '';
    this.isTopMenu = this.newsletterContent.MenuLocation != null && this.newsletterContent.MenuLocation == 'Top';

  }

  routingTabActive() {
    const id = this.router.url.slice(this.router.url.indexOf('_') + 1);
    this.newsletterContent.PageContent.forEach((item: PageContentDto) => {
      item.active = item.Id === id;
      if (item.active) {
        this.scrollToAnchor(('DTX_' + item.Anchor) as string);
        this.router.navigate(['.'], {
          relativeTo: this.activatedRoute,
          fragment: ('DTX_' + item.Id) as string,
          queryParamsHandling: 'preserve',
        });
      }
    });
  }

  reloadTabActive() {
    const anchor = this.router.url.slice(this.router.url.indexOf('#') + 1);
    this.newsletterContent.PageContent.forEach((item: PageContentDto) => {
      item.active = item.Anchor === anchor;
    });
  }

  menuItems() {
    return this.newsletterContent.PageContent.filter((item: PageContentDto) => item.IndexShow && (item.Title || item.IndexTitle));
  }

  /**
   * Scroll to anchor
   * @param anchor
   */
  scrollToAnchor(anchor: string) {
    this.lastScrolledTo = anchor;
    // this.viewportScroller.scrollToAnchor(anchor);
  }

  /**
   * Update class of clicked menu item
   */
  updateActiveClass(menuItemId: string) {
    this.newsletterContent.PageContent.forEach((item: PageContentDto) => {
      item.active = item.Id === menuItemId;
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if ((window.innerWidth < 992 || this.isTopMenu) && this.expandMenu) {
      this.renderer.addClass(this.document.body, 'add-scroll-overflow');
    }
    if (window.scrollY == 0 || !this.expandMenu) {
      this.renderer.removeClass(this.document.body, 'add-scroll-overflow');
    }
  }

  openNewsletterTab() {
    if (this.isTopMenu) {
      this.breakpointObserver.observe(['(min-width: 0)']).subscribe(() => {
        this.handleExpand();
      });
    } else {
      this.breakpointObserver.observe(['(min-width: 0) and (max-width: 992px)']).subscribe(() => {
        this.handleExpand();
      });
    }

    this.expandMenu = !this.expandMenu;
  }

  private handleExpand() {
    if (!this.expandMenu) {
      this.renderer.addClass(this.document.body, 'add-overflow-css');
    } else {
      this.renderer.removeClass(this.document.body, 'add-overflow-css');
    }
  }

  handleNavigate(menuItem: PageContentDto) {
    this.expandMenu = !this.expandMenu;
    this.handleExpand();
    const anchor = this.uniqueAnchors.handlingAnchors(menuItem);
    this.scrollToAnchor(anchor);
    this.updateActiveClass(menuItem.Id as string);

    this.router.navigate(['.'], {
      relativeTo: this.activatedRoute,
      fragment: anchor,
      queryParamsHandling: 'preserve',
    });
    this.document.getElementsByTagName('html')[0].classList.add('scroll-smooth');
  }

  ngOnDestroy() {
    this.document.getElementsByTagName('html')[0].classList.remove('scroll-smooth');
  }
}
